import isEmpty from "lodash/isEmpty";
import { useDispatch, useSelector } from "react-redux";

import DrawerSnap from "@components/shared/DrawerSnap/DrawerSnap";
import { BookingFetchResponseType } from "@models/services/booking";
import bookingCalendarSlice from "@slices/bookingCalendar.slice";
import drawerSlice from "@slices/drawer.slice";
import { RootState } from "@store/index";

import DrawerTimeSlot from "../DrawerTimeSlot/DrawerTimeSlot";

const BookingCalendarDrawer = ({
  bookingSlots,
  checkBookingDisable,
  priceLoader,
}: {
  checkBookingDisable: () => boolean;
  bookingSlots: BookingFetchResponseType;
  priceLoader: boolean;
}) => {
  const dispatch = useDispatch();

  const showBookingDrawer = useSelector(
    (state: RootState) => state.drawer.showBookingDrawer
  );

  const handleDrawerClose = () => {
    dispatch(drawerSlice.actions.removeDrawerBookingState(null));
    dispatch(bookingCalendarSlice.actions.setTempEvents([]));
  };

  return (
    <DrawerSnap
      isOpen={showBookingDrawer}
      onClose={handleDrawerClose}
      direction="bottom"
      useSnapPoints={true}
    >
      {isEmpty(bookingSlots) ? null : (
        <DrawerTimeSlot
          isBookingDisable={checkBookingDisable()}
          priceLoader={priceLoader}
          bookingSlots={bookingSlots}
        />
      )}
    </DrawerSnap>
  );
};

export default BookingCalendarDrawer;
